import { render, staticRenderFns } from "./keysToKennel.vue?vue&type=template&id=8b1b76f8&scoped=true&"
import script from "./keysToKennel.vue?vue&type=script&lang=js&"
export * from "./keysToKennel.vue?vue&type=script&lang=js&"
import style0 from "./keysToKennel.vue?vue&type=style&index=0&id=8b1b76f8&lang=scss&scoped=true&"
import style1 from "./keysToKennel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b1b76f8",
  null
  
)

export default component.exports